import React from "react";
import "@frameworks/salesjourney/stylesheets/components/Features/AccountOpening/AccountOpening.scss";
import CustomTooltipTop from "@frameworks/shared-library/components/CustomTooltipTop";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
var AccountOpeningCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, description = _a.description, products = _a.products, buttonText = _a.buttonText, minWidth = _a.minWidth, navigateTo = _a.navigateTo, tooltipTitle = _a.tooltipTitle;
    var visibleProducts = products.slice(0, 7);
    var hiddenProducts = products.slice(7);
    return (React.createElement("div", { className: "account-card" },
        React.createElement("div", null,
            React.createElement("h2", { className: "title" }, title),
            subtitle.includes("+") ? (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "subtitle" }, subtitle.split("+")[0].trim()),
                React.createElement("p", { className: "subtitle" }, "+"),
                React.createElement("p", { className: "subtitle" }, subtitle.split("+")[1].trim()))) : (React.createElement("p", { className: "subtitle" }, subtitle)),
            React.createElement("p", { className: "description" }, description),
            React.createElement("div", { className: "products" },
                visibleProducts.map(function (item, index) { return (React.createElement("div", { key: index, className: "product-item" },
                    React.createElement("i", { className: "".concat(item.icon, " product-icon") }),
                    React.createElement("span", { className: "product-item-subtext" }, item.name))); }),
                hiddenProducts.length > 0 && (React.createElement(CustomTooltipTop, { tooltipContent: React.createElement("div", { className: "more-products hand_cursor" },
                        React.createElement("span", { className: "tooltip-title" }, tooltipTitle),
                        hiddenProducts.length > 10 ? (React.createElement("div", { className: "product-tooltip", style: { minWidth: minWidth } },
                            React.createElement("div", { className: "section" },
                                React.createElement("ul", null, hiddenProducts
                                    .slice(0, Math.ceil(hiddenProducts.length / 2))
                                    .map(function (item, idx) { return (React.createElement("li", { key: idx, style: { marginBottom: "8px" } },
                                    item.name,
                                    item.subtext && React.createElement("span", null,
                                        " ",
                                        item.subtext))); }))),
                            React.createElement("div", { className: "section" },
                                React.createElement("ul", null, hiddenProducts
                                    .slice(Math.ceil(hiddenProducts.length / 2))
                                    .map(function (item, idx) { return (React.createElement("li", { key: idx },
                                    item.name,
                                    item.subtext && React.createElement("span", null,
                                        " ",
                                        item.subtext))); }))))) : (React.createElement("div", { className: "product-tooltip" },
                            React.createElement("div", { className: "section" },
                                React.createElement("ul", null, hiddenProducts.map(function (item, idx) { return (React.createElement("li", { key: idx },
                                    item.name,
                                    item.subtext && React.createElement("span", null,
                                        " ",
                                        item.subtext))); })))))) },
                    React.createElement("div", { className: "more-products-underline hand_cursor" },
                        React.createElement("span", null,
                            "+",
                            hiddenProducts.length,
                            " more products")))))),
        React.createElement(EdButton, { btnTyp: "tomato", value: buttonText, onClick: function () {
                if (navigateTo) {
                    window.open(navigateTo, "_blank");
                }
            }, className: "account-button DMSan_14_500 hand_cursor" })));
};
export default AccountOpeningCard;
